module.exports = __webpack_public_path__ + "img/info.a1377637.gif";